import React, { ReactElement, useEffect, useState } from 'react';
import useDebounce from '../utils/debounce';

interface FetchActivitiesProps {
  title: string;
}

interface FetchActivities {
  (props: FetchActivitiesProps): void;
}

interface SearchSidebarProps {
  fetchActivities: FetchActivities;
}

export default function SearchSidebar({ fetchActivities }: SearchSidebarProps): ReactElement {
  const [searchText, setSearchText] = useState('');
  const debouncedSearchText = useDebounce(searchText, 500);
  useEffect(() => {
    fetchActivities({ title: debouncedSearchText });
  }, [debouncedSearchText, fetchActivities]);
  return (
    <div className="contextual-region block block-sidebar-first hb-container closed">
      <div className="block-title">
        <h3>
          <span className="disable-select">Fritext filter</span>
          <div className="hb-toggle-trigger">
            <div className="hb-toggle">
              <div className="hb-toggle-icon" />
            </div>
          </div>
        </h3>
      </div>

      <div className="block-content-outer hb-item-content">
        <div className="block-content hb-item-content-inner">
          <form
            onSubmit={(e): void => {
              e.preventDefault();
            }}
          >
            <div>
              <input
                onChange={(event): void => {
                  event.preventDefault();
                  setSearchText(event.target.value);
                }}
                value={searchText}
                type="search"
                id="filter-activities-result"
                name="filter-activities-result"
                placeholder="Filtrera resultat"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
